import { render, staticRenderFns } from "./CmhLogo.vue?vue&type=template&id=49150e84&scoped=true"
import script from "./CmhLogo.vue?vue&type=script&lang=ts"
export * from "./CmhLogo.vue?vue&type=script&lang=ts"
import style0 from "./CmhLogo.vue?vue&type=style&index=0&id=49150e84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49150e84",
  null
  
)

export default component.exports